/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InitMetadata } from './initMetadata';

/**
 * Init flow request
 */
export interface InitFlowRequest {
  promotionCode?: string;
  campaignCode?: string;
  ratingDate?: string;
  metadata?: InitMetadata;
}
